import { Box, Typography, Chip, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FileNameCell = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    minWidth: 0,
}));

export const FileDetails = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    gap: '2px',
    flex: 1,
}));

export const FileName = styled(Typography)(({ theme }) => ({
    fontWeight: 500,
    fontSize: '15px',
    color: '#1e293b',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}));

export const TypeBadge = styled(Chip)(({ theme }) => ({
    backgroundColor: '#f1f5f9',
    color: '#475569',
    fontSize: '12px',
    fontWeight: 600,
    height: '28px',
    '& .MuiChip-label': {
        padding: '0 10px',
    },
}));

export const StatusIndicator = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '15px',
    fontWeight: 500,
}));

export const StatusDot = styled(Box)(({ theme, status }) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor:
        status === 'completed' ? '#059669' :
            status === 'processing' ? '#3b82f6' :
                status === 'failed' ? '#dc2626' :
                    '#059669',
}));

export const ProgressContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    minWidth: '120px',
}));

export const ProgressText = styled(Typography)(({ theme }) => ({
    fontSize: '13px',
    fontWeight: 600,
    minWidth: '45px',
    textAlign: 'right',
    color: '#64748b',
}));

export const ActionButton = styled(Button)(({ theme }) => ({
    width: '100%',
    backgroundColor: '#000000',
    color: '#ffffff',
    padding: '12px',
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
    marginTop: '24px',
    '&:hover': {
        backgroundColor: '#333333',
    },
    '&:disabled': {
        backgroundColor: '#e2e8f0',
        color: '#94a3b8',
    },
}));

export const StatusChip = styled(Chip)(({ theme }) => ({
    height: '24px',
    fontSize: '12px',
    backgroundColor: '#dcfce7',
    color: '#166534',
    '& .MuiChip-icon': {
        color: '#166534',
        width: '14px',
        height: '14px',
    },
}));

export const ItemTitle = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    color: '#334155',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '400px',
}));
